import { Component, computed, input } from '@angular/core';

import type {
  AggregatedEvaluationsSkillStatus,
  AggregatedEvaluationsSkillSummaryRating,
} from '@core/evaluations-types';
import { TranslatePipe } from '@core/i18n-legacy';
import { RtTooltip } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-evaluation-skill-scale-rating',
  templateUrl: './evaluation-skill-scale-rating.component.html',
  styleUrl: './evaluation-skill-scale-rating.component.less',
  imports: [RtTooltip, TranslatePipe],
})
export class EvaluationSkillScaleRatingComponent {
  protected readonly scale = computed(() =>
    Array.from({ length: this.rating().scale }, (_, index) => index + 1),
  );

  public rating = input.required<AggregatedEvaluationsSkillSummaryRating>();

  public status = input.required<AggregatedEvaluationsSkillStatus>();
}
